import { CUBE_ORDER, type CubeOrderValue } from '@/constants.ts'
import type { MapStore } from '@/stores/useMapStore'
import type { CubeMapData } from '@/types/CubeDto'



const sortFactory = (order: CubeOrderValue = CUBE_ORDER.SHORTEST_DISTANCE_FIRST, mapStore: MapStore) => {
  const _price = (cube: CubeMapData, defaultPrice: number) => {
    if (!cube.hasProduction) {
      return defaultPrice
    }

    const prices = mapStore.getProducerPrices(cube.cubeName)

    if (prices && prices.currentPrice) {
      return prices.currentPrice
    }

    return defaultPrice
  }

  const priceLowestFirst = (cube: CubeMapData) => _price(cube, 50)
  const priceHighestFirst = (cube: CubeMapData) => _price(cube, 0)

  switch (order) {
    case CUBE_ORDER.SHORTEST_DISTANCE_FIRST:
      return (cubeA: CubeMapData, cubeB: CubeMapData) => cubeA.distance - cubeB.distance

    case CUBE_ORDER.LONGEST_DISTANCE_FIRST:
      return (cubeA: CubeMapData, cubeB: CubeMapData) => cubeB.distance - cubeA.distance

    case CUBE_ORDER.LOWEST_PRICE_FIRST:
      return (cubeA: CubeMapData, cubeB: CubeMapData) => priceLowestFirst(cubeA) - priceLowestFirst(cubeB)

    case CUBE_ORDER.HIGHEST_PRICE_FIRST:
      return (cubeA: CubeMapData, cubeB: CubeMapData) => priceHighestFirst(cubeB) - priceHighestFirst(cubeA)

    case CUBE_ORDER.BIGGEST_PRODUCTION_FIRST:
      return (cubeA: CubeMapData, cubeB: CubeMapData) => {
        const peakA = mapStore.getCubeByName(cubeA.cubeName)?.params?.productionCapacityKWp ?? 0
        const peakB = mapStore.getCubeByName(cubeB.cubeName)?.params?.productionCapacityKWp ?? 0
        return peakB - peakA
      }

    case CUBE_ORDER.MOST_LIKES:
      return (cubeA: CubeMapData, cubeB: CubeMapData) => cubeB.numLikes - cubeA.numLikes
  }

  return (cubeA: CubeMapData, cubeB: CubeMapData) => 0;
}

export { sortFactory }
